import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import markdown from '@opsbase/react-markdown';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import TextField from '@opsbase/web-textfield/TextField';
import Spinner from '@opsbase/web-ui/Spinner';
import Text from '@opsbase/web-ui/Text';
import * as React from 'react';
import useOpSchedules from "@opsbase/react-gql-hooks/opschedule/useOpSchedules";
const styles = {
    container: {
        borderRadius: 3,
        padding: 20,
        backgroundColor: Palette.White.main,
        border: `1px solid ${Palette.InputBorderGrey.main}`,
    },
};
export default function AddSchedule(props) {
    var _a, _b;
    const { id } = props;
    const { loading, data: opSchedules } = useOpSchedules({
        variables: { opDefinition: id },
        skip: !id,
    });
    let opSchedule = opSchedules === null || opSchedules === void 0 ? void 0 : opSchedules[0];
    const startFrom = (_a = opSchedule === null || opSchedule === void 0 ? void 0 : opSchedule.dueDate) === null || _a === void 0 ? void 0 : _a.clone().subtract(opSchedule.whenCanStart, 'minutes').format('HH:mm');
    const completeBy = (_b = opSchedule === null || opSchedule === void 0 ? void 0 : opSchedule.dueDate) === null || _b === void 0 ? void 0 : _b.format('HH:mm');
    return (React.createElement(Vertical, { gutter: true, paddingX: true },
        React.createElement(Spinner, { busy: loading || !opSchedule }, () => (React.createElement(Vertical, { gutter: true },
            React.createElement(Text, { variant: 'h1' }, i18n.t('schedule')),
            React.createElement(Text, null, i18n.t('schedule-line1')),
            React.createElement(Text, { style: { marginTop: -8 } }, markdown(i18n.t('schedule-line2'))),
            React.createElement(Text, { style: { marginTop: -8 } }, markdown(i18n.t('schedule-line3'))),
            React.createElement(Text, null, i18n.t('schedule-line4')),
            React.createElement("div", { style: styles.container },
                React.createElement(TextField, { disabled: true, value: i18n.t('daily'), fullWidth: true }),
                React.createElement(Horizontal, { stretch: true },
                    React.createElement(Horizontal, { justify: 'flex-start', centered: true, gutter: true },
                        React.createElement(Text, null, i18n.t('start-from')),
                        React.createElement(TextField, { disabled: true, value: startFrom, inputProps: {
                                size: 10,
                            } })),
                    React.createElement(Horizontal, { justify: 'flex-start', centered: true, gutter: true },
                        React.createElement(Text, null, i18n.t('complete-by')),
                        React.createElement(TextField, { disabled: true, value: completeBy, inputProps: {
                                size: 10,
                            } })))))))));
}
